<a [routerLink]="'department/'+deptData?.slug" class="each-policy position-relative d-block" *ngIf="deptData">
    <div class="img-wrapper" *ngIf="deptData?.HeroSectionDepartment?.Image?.data?.attributes?.formats?.thumbnail?.url">
        <img [src]="imageUrl+deptData?.HeroSectionDepartment?.Image?.data?.attributes?.formats?.thumbnail?.url" alt="Announcements Image">
    </div>
    <h4 class="heading sec-heading3" *ngIf="deptData?.Name">{{deptData.Name}}</h4>
</a>